module.exports = __webpack_public_path__ + "static/media/ball_a.1cd0b9eb.png";